import { ServerAsset } from '@sequencehq/api'
import { useCurrentContract } from 'ContractExtraction/hooks/useContract'
import { useSelectBillingScheduleAttachments } from 'Cube/domain/subdomain/attachments'
import { useEffect, useState } from 'react'
import { useSearchParams } from 'react-router-dom'

type UseAutoDisplayContractAttachment = () =>
  | {
      showContentOnMount: boolean
      defaultItemId: string
      defaultAttachment: ServerAsset
      onSelectedPreviewChange: () => void
    }
  | undefined

export const AUTO_DISPLAY_CONTRACT_ATTACHMENT_QUERY_PARAM_KEY: string =
  'showContractAsset'
export const ATTACHMENTS_INSPECTOR_ID: string = 'billing-schedule-attachments'

export const useAutoDisplayContractAttachment: UseAutoDisplayContractAttachment =
  () => {
    const [searchParams, setSearchParams] = useSearchParams()

    const attachments = useSelectBillingScheduleAttachments()
    const { data: contractData } = useCurrentContract()

    const [isActive, setIsActive] = useState<boolean>(true)

    // biome-ignore lint/correctness/useExhaustiveDependencies: only on mount
    useEffect(() => {
      const value = searchParams.get(
        AUTO_DISPLAY_CONTRACT_ATTACHMENT_QUERY_PARAM_KEY
      )
      setIsActive(value === 'true')
    }, [])

    const defaultAttachment = attachments.find(
      attachment => attachment.id === contractData?.assetId
    )

    return isActive && defaultAttachment
      ? {
          showContentOnMount: true,
          defaultItemId: ATTACHMENTS_INSPECTOR_ID,
          defaultAttachment,
          onSelectedPreviewChange: () => {
            setSearchParams(prev => {
              prev.delete(AUTO_DISPLAY_CONTRACT_ATTACHMENT_QUERY_PARAM_KEY)
              return prev
            })

            setIsActive(false)
          }
        }
      : undefined
  }
